import { type ReactElement, type ReactNode } from "react"
import { User } from "src/features/authentication/types/AuthTypes"

export interface ProfileManagerProps {
        user?: User | null,
        children?: ReactNode
}

export default function ProfileManager(props: ProfileManagerProps): ReactElement {

        return <>
                <div className="text-white p-2 pr-4">
                        <div className="flex gap-1 justify-center items-center">
                                <label className="content-center">{props.user?.LastName + " ," + props.user?.FirstName}</label>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        </div>
                </div>
        </>
}

